// extracted by mini-css-extract-plugin
module.exports = {"tag":"tag_tag__sFzRA","tag__row":"tag_tag__row__KUJ2G","tag__term":"tag_tag__term__7Kqu4","tag__desc":"tag_tag__desc__8HCbe"};